export const textOverridesKeys = {
  all: ['textOverrides'] as const,
  org: (orgId: string) => [...textOverridesKeys.all, orgId] as const,
  bundles: (orgId: string) => [...textOverridesKeys.org(orgId), 'bundle'] as const,
  bundle: (orgId: string, locale: string) => [...textOverridesKeys.bundles(orgId), locale] as const,
  version: (orgId: string) => [...textOverridesKeys.org(orgId), 'version'] as const,
};
